// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"c528f1ff","131":"409074d5"}[chunkId] + ".chunk.css";
};